import React, { useEffect, useState } from 'react';
import { getExpressParams } from '../../../service/api';
import InsightMain from '../../presentation/section/insight-page/InsightMain';

const Insight = (props) => {
  const [pageNum, setPageNum] = useState(0);
  const [insightContent, setInsightContent] = useState([]);

  useEffect(() => {
    getExpressParams('/notice/insight', {
      index: pageNum,
      isInsight: 1
    }, (response) => {
      for(const item of response.data) {
        setInsightContent(insightContent => [...insightContent, item]);
      }
    })
  }, [])

  return (
    <>
      <InsightMain insightContent={insightContent} />
      {/* <div dangerouslySetInnerHTML={{__html: code}}></div> */}
    </>
  )
}

export default Insight;
